import { Navigate } from "react-router-dom";
import { useAuth as useClerkAuth } from "@clerk/clerk-react";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

function FullScreenLoader() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-3" data-testid="auth-loading">
      <Loader2 className="w-8 h-8 text-sky-500 animate-spin" />
      <p className="text-sm text-slate-400">Menyiapkan dashboard…</p>
    </div>
  );
}

export default function ProtectedRoute({ children }) {
  const { isLoaded, isSignedIn } = useClerkAuth();
  const { user } = useAuth();

  // Clerk still booting up.
  if (!isLoaded) return <FullScreenLoader />;
  // Clerk loaded and definitely signed out.
  if (!isSignedIn) return <Navigate to="/login" replace />;
  // Signed in, but our app profile (/auth/me) is still loading.
  if (user === null || user === false) return <FullScreenLoader />;

  return children;
}
